export default __webpack_public_path__ + "static/media/client2.d97cc058.jpg";